import { z } from 'zod';

export const InsuranceOfferSchema = z.object({
  specification: z.string(),
  agreements: z.array(
    z.object({
      agreementText: z.string(),
      agreementTextHtml: z.string(),
      key: z.string(),
      mandatory: z.boolean(),
    }),
  ),
  description: z.string(),
  documents: z.array(
    z.object({
      key: z.string(),
      label: z.string(),
      text: z.string(),
      url: z.string(),
    }),
  ),
  id: z.string(),
  name: z.string(),
  selected: z.boolean(),
  totalPremium: z.object({
    amount: z.number(),
    currency: z.string(),
    symbol: z.string(),
  }),
  totalPremiumText: z.string(),
});
